import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'emphasize'
})
export class EmphasizePipe implements PipeTransform {

  transform(text: string, emphasis: string): string {
    const regex = new RegExp(emphasis || null, 'gi');
    const matches = (text || '').match(regex);
    const rest = (text || '').split(regex);
    return rest.reduce((acc, val, i) => acc + '<strong>' + matches[i - 1] + '</strong>' + val);
  }

}
